import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/common/components/ui/table';

export const CarSectionsTableHeader = () => {
  const { t } = useTranslation();

  return (
    <TableHeader>
      <TableRow>
        <TableHead className="rounded-tl-lg border-r border-warm-gray-200 min-w-[200px] font-bold text-left">
          {t('garantie.garanties')}
        </TableHead>
        <TableHead className="border-r border-warm-gray-200 min-w-[120px] font-bold text-right">
          {t('garantie.montantAssurance')}
        </TableHead>
        <TableHead className="border-r border-warm-gray-200 min-w-[92px] font-bold text-right">
          {t('garantie.franchise')}
        </TableHead>
        <TableHead className="rounded-tr-lg min-w-[92px] font-bold text-right">
          {t('garantie.prime')}
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};
